export const PROPERTY_PLACEHOLDER_SRC = "/assets/images/property-placeholder.svg";

function hasValue(value) {
  return typeof value === "string" && value.trim().length > 0;
}

/**
 * Find the best card-eligible image from the images array.
 * Falls back to first image if none are card-eligible.
 */
function getBestCardEligibleUrl(images) {
  if (!Array.isArray(images) || !images.length) return null;

  const eligible = images.filter((img) => img.isCardEligible !== false && !img.isBroken);
  const sorted = [...(eligible.length ? eligible : images)]
    .filter((img) => hasValue(img.url))
    .sort((a, b) => (Number(b.qualityScore) || 0) - (Number(a.qualityScore) || 0));

  return sorted[0]?.url?.trim() || null;
}

/**
 * Resolve the best primary image URL for a Client View listing.
 * Prefers card-eligible images with the highest quality score.
 */
export function getPrimaryListingImageUrl(listing = {}) {
  const cardUrl = getBestCardEligibleUrl(listing.images || listing.media?.images);
  if (cardUrl) return cardUrl;

  const candidates = [
    listing.primaryImageUrl,
    listing.thumbnailUrl,
    listing.media?.primaryImageUrl,
    listing.media?.thumbnailUrl,
    listing.images?.[0]?.url,
    listing.images?.[0]?.thumbnailUrl,
    listing.imageUrl,
  ];

  for (const candidate of candidates) {
    if (hasValue(candidate)) {
      return candidate.trim();
    }
  }

  return null;
}

export function getListingImageCount(listing = {}) {
  const count =
    listing.imageCount ??
    listing.photoCount ??
    listing.media?.imageCount ??
    listing.images?.length ??
    0;

  return Number.isFinite(Number(count)) ? Number(count) : 0;
}
